import { HTMLAttributes } from "react";

import { SideMenuOptionContainer } from "./styles";

interface ISideMenuOptionProps {
  onClick: () => void;
  LeftIcont: (props?: HTMLAttributes<HTMLElement>) => JSX.Element;
  title: string;
  active?: boolean;
  className?: string;
}

function SideMenuOption({
  onClick,
  LeftIcont,
  title,
  active,
  className,
}: ISideMenuOptionProps) {
  return (
    <SideMenuOptionContainer onClick={onClick}>
      <div className={`menuOption ${active && "active"} ${className}`}>
        <LeftIcont className="icon" />

        <div className="text">
          <h2 className="title">{title}</h2>
        </div>
      </div>
    </SideMenuOptionContainer>
  );
}

export default SideMenuOption;
